import React from 'react'

import { noop } from '#util'

import { ThreadOperations, ThreadPojo } from './types'

// if the user is editing an existing comment, we need to know
// the state of that to know whether to block de-selection
export type EditedComment = {
  id: string
  originalText: string
  newText: string
}

export type ThreadContextState = {
  thread: ThreadPojo
  threadSelected: boolean
  operations: ThreadOperations
  // when a comment is being edited
  // editingCommentId?: string
  // setEditingCommentId: (commentId: string) => void
  // when adding a new comment
  unsavedNewCommentText?: string
  setUnsavedNewCommentText: (text: string) => void
  editedComment: EditedComment | null
  setEditedComment: (value: EditedComment | null) => void
}

export const ThreadContext = React.createContext<ThreadContextState>({
  thread: {
    id: 'dummy',
    snippet: 'dummy',
    updatedAt: new Date(),
    resolvedAt: new Date(),
    comments: [],
  },
  threadSelected: false,
  operations: {},
  setUnsavedNewCommentText: noop,
  editedComment: null,
  setEditedComment: noop,
})
